import { el } from "./dom.ts";
import { icons } from "./icons.ts";

interface Shortcut {
  keys: string[];
  what: string;
}

const GLOBAL: Shortcut[] = [
  { keys: ["/"], what: "Jump to search" },
  { keys: ["?"], what: "This list" },
  { keys: ["Esc"], what: "Close a player, menu or dialog" },
];

const PLAYER: Shortcut[] = [
  { keys: ["Space"], what: "Play or pause" },
  { keys: ["←", "→"], what: "Back or forward five seconds" },
  { keys: ["↑", "↓"], what: "Volume" },
  { keys: ["M"], what: "Mute" },
  { keys: ["F"], what: "Fullscreen" },
  { keys: ["P"], what: "Picture in picture" },
  { keys: ["[", "]"], what: "Dimmer or brighter" },
];

function row(shortcut: Shortcut): HTMLElement {
  const keys = el("span", { class: "shortcut-keys" });
  for (const key of shortcut.keys) {
    keys.append(el("kbd", { class: "kbd", text: key }));
  }
  return el("div", { class: "shortcut-row" }, keys, el("span", { class: "shortcut-what", text: shortcut.what }));
}

/**
 * The whole keyboard in one place. Built on <dialog> so the browser supplies
 * the focus trap, the Escape key and the backdrop; the only thing this adds is
 * the content and its close button.
 */
export function showShortcuts(): void {
  if (document.getElementById("shortcuts")) return;
  const dialog = el("dialog", {
    class: "shortcuts",
    attrs: { id: "shortcuts", "aria-labelledby": "shortcuts-title" },
  });

  const close = el("button", {
    class: "coin shortcuts-close",
    attrs: { type: "button", "aria-label": "Close the shortcut list" },
    html: icons.close,
  });
  close.addEventListener("click", () => dialog.close());

  dialog.append(
    el(
      "div",
      { class: "shortcuts-head" },
      el("h2", { class: "shortcuts-title", attrs: { id: "shortcuts-title" }, text: "Keyboard" }),
      close,
    ),
    el("p", { class: "shortcuts-lead", text: "Everything works with the keyboard alone. This is the whole set." }),
    el("h3", { class: "shortcuts-group", text: "Anywhere" }),
    ...GLOBAL.map(row),
    el("h3", { class: "shortcuts-group", text: "In the player" }),
    ...PLAYER.map(row),
  );

  dialog.addEventListener("close", () => dialog.remove());
  dialog.addEventListener("click", (event) => {
    // A click on the backdrop closes, the way a modal is expected to behave.
    if (event.target === dialog) dialog.close();
  });

  document.body.append(dialog);
  dialog.showModal();
  close.focus({ preventScroll: true });
}
